// extracted by mini-css-extract-plugin
module.exports = {"colorPickerOverlay":"EditTextScene__colorPickerOverlay___1DbOg"};